var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"hoc-back-button",on:{"click":function($event){return _vm.$emit('backIconClicked')}}},[_c('i',{staticClass:"fal fa-chevron-left"})])])}
var staticRenderFns = []

export { render, staticRenderFns }